import 'css-chunksrc/client/scenes/folderCreation/form/folderSelection/styles.scss';export default {
  "input": "_input_19tsi_1",
  "placeholder": "_placeholder_19tsi_15",
  "icon": "_icon_19tsi_22",
  "listRoot": "_listRoot_19tsi_28",
  "list": "_list_19tsi_28",
  "opened": "_opened_19tsi_44"
};